var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaemin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 340.2 88.7",
    style: {
      enableBackground: "new 0 0 340.2 88.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M340.2,10.6L334,4.5h-52.7v4.1l-3.5-4.1H225v3.8l-3.5-4.1h-13.9v2.3l-1.5-2h-7.6L194.4,0h-13.9v4.5h-11.7v4.1l-3.5-4.1 h-13.9v2l-1.5-2h-7.6L138.1,0h-13.9v4.5h-11.7v4.1l-3.7-4.1H94.9v10.8L84.1,4.5H65.5l-9.4,9.4v3.3L43.3,4.5h-34L0,13.9v20.8 l12,11.9H0v13.9l6.2,6.1h13.3v16l6.2,6.1h13.9V66.6H59V53.9l12.8,12.7h18.6l4.7-4.7v20.7l6.2,6.1H115v-4.1l3.7,4.1h52.7v-8.2 l-4.9-7.2h6.7l15.6,15.5h29.6l9.4-9.4V67.2l-9.4-9.4l0,0l-0.6-0.6h10v-2l1.9,2h11.8l3.8-13.7l2.1,7.6l6.2,6.1h4.8v25.4l6.2,6.1 h19.6v-4.1l3.5,4.1h52.7V76.5l-4.1-3.6h4.1V49.3l-3.1-2.4h3.1v-9.8l-3.1-2.8h3.1V22.1l-2.1-1.7h2.1v-9.8H340.2z M208.6,51.7 L208.6,51.7L208.6,51.7L208.6,51.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,6.4l-8.3,8.3V34l8.3,8.3h32.4l8.3-8.3V14.7l-8.3-8.3C42.5,6.4,10.1,6.4,10.1,6.4z M40.7,32.1H12V16.6 h28.6v15.5H40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,6.4l-8.3,8.3v35.7l8.3,8.3h17.1l8.3-8.3V14.7l-8.3-8.3C83.3,6.4,66.2,6.4,66.2,6.4z M81.4,48.5H68.1 V16.6h13.3V48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.7,58.7l8.3-8.3V24.5l-8.3-8.3h-17.1l-8.3,8.3v25.9l8.3,8.3H139.7z M124.6,26.4h13.3v22.1h-13.3 C124.6,48.5,124.6,26.4,124.6,26.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.8,58.7 21.3,58.7 21.3,80.8 31.5,80.8 31.5,58.7 50.9,58.7 50.9,48.5 1.8,48.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "148,6.4 136.3,6.4 136.3,1.8 126.1,1.8 126.1,6.4 114.3,6.4 114.3,12.5 148,12.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107,6.4 96.8,6.4 96.8,80.8 107,80.8 107,39.9 110.6,39.9 110.6,29.7 107,29.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124.6,61.4 114.3,61.4 114.3,80.8 163.4,80.8 163.4,70.6 124.6,70.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "163.4,6.4 153.2,6.4 153.2,58.7 163.4,58.7 163.4,39.9 167.3,39.9 167.3,29.7 163.4,29.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,49.5l8.3-8.3V24.5l-8.3-8.3h-17.1l-8.3,8.3v16.7l8.3,8.3H196z M180.8,26.4h13.3v12.9h-13.3V26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.3,53.6l-8.3,8.3v10.6l8.3,8.3h28.1l8.3-8.3V61.9l-8.3-8.3C211.4,53.6,183.3,53.6,183.3,53.6z  M209.5,70.6h-24.3v-6.8h24.3V70.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "204.3,6.4 192.5,6.4 192.5,1.8 182.3,1.8 182.3,6.4 170.6,6.4 170.6,12.5 204.3,12.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "209.5,16.2 207.2,16.2 207.2,26.4 209.5,26.4 209.5,32.3 207.2,32.3 207.2,42.5 209.5,42.5  209.5,49.3 219.7,49.3 219.7,6.1 209.5,6.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 32.8,
    className: "st0",
    width: 49.1,
    height: 6.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "283.1,26.4 332.2,26.4 332.2,17.8 293.3,17.8 293.3,12.5 332.2,12.5 332.2,6.4 283.1,6.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "283.1,80.8 332.2,80.8 332.2,72.2 293.3,72.2 293.3,64.9 332.2,64.9 332.2,45 283.1,45 283.1,53.6  322,53.6 322,58.8 283.1,58.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "256.1,12.5 256.1,6.4 226.9,6.4 226.9,12.5 235.9,12.5 225.8,49.3 233.7,49.3 241.2,22.3 248.6,49.3  256.5,49.3 246.4,12.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 6.4,
    className: "st0",
    width: 6.1,
    height: 74.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "260,21.9 255.7,21.9 255.7,32.1 260,32.1 260,80.8 266.1,80.8 266.1,6.4 260,6.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaemin);
export default __webpack_public_path__ + "static/media/baemin.b6e7121cdd08adfb112b3a96c9fd15a2.svg";
export { ForwardRef as ReactComponent };